import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import moment from "moment";
import i18n from "./i18n"
import "@/util/filter";

require("es6-promise/auto");

// import Vconsole from 'vconsole';
// new Vconsole();

Vue.config.productionTip = false;
Vue.prototype.moment=moment;
Vue.prototype.$vue=Vue;


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
